import { MapHex } from "../../lib/interfaces";
import parse from 'html-react-parser';

interface InfoProps {
    data: MapHex;
}

export default function Info({ data }: InfoProps) {
    return <div className="panel">
        <h2>{data.label}</h2>
        <p>{parse(data.description)}</p>
        <h3>{data.detail1.label}</h3>
        {parse(data.detail1.description)}
        <h3>{data.detail2.label}</h3>
        {parse(data.detail2.description)}
        <h3>{data.detail3.label}</h3>
        {parse(data.detail3.description)}
    </div>;
}
